module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui huge menu"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.triggerMenu($event)
      }
    }
  }, [_c('i', {
    staticClass: "content icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui centered grid"
  }, [_c('div', {
    staticClass: "ui ten wide column"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('table', {
    staticClass: "ui very basic striped table"
  }, [_c('tr', [_c('td', [_vm._v("Admin overrides current user selection")]), _vm._v(" "), _c('td', {
    staticClass: "right aligned four wide"
  }, [_c('div', {
    staticClass: "ui checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.adminOverridesSelected),
      expression: "settings.adminOverridesSelected"
    }],
    attrs: {
      "type": "checkbox",
      "id": "adminOverridesSelected"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.adminOverridesSelected) ? _vm._i(_vm.settings.adminOverridesSelected, null) > -1 : (_vm.settings.adminOverridesSelected)
    },
    on: {
      "change": _vm.trackChange,
      "__c": function($event) {
        var $$a = _vm.settings.adminOverridesSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.settings.adminOverridesSelected = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.settings.adminOverridesSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settings.adminOverridesSelected = $$c
        }
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Booking session timeout warning shows after")]), _vm._v(" "), _c('td', {
    staticClass: "four wide"
  }, [_c('div', {
    staticClass: "ui right labeled input",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.sessionTimeout),
      expression: "settings.sessionTimeout"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter time"
    },
    domProps: {
      "value": (_vm.settings.sessionTimeout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.sessionTimeout = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("\n                                        min\n                                    ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Upon warning, booking gets cleared after")]), _vm._v(" "), _c('td', {
    staticClass: "four wide"
  }, [_c('div', {
    staticClass: "ui right labeled input",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.sessionTimeoutClear),
      expression: "settings.sessionTimeoutClear"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter time"
    },
    domProps: {
      "value": (_vm.settings.sessionTimeoutClear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.sessionTimeoutClear = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("\n                                        min\n                                    ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("How many minutes before can booking be made?")]), _vm._v(" "), _c('td', {
    staticClass: "four wide"
  }, [_c('div', {
    staticClass: "ui right labeled input",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.bookingAllowedBefore),
      expression: "settings.bookingAllowedBefore"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter time"
    },
    domProps: {
      "value": (_vm.settings.bookingAllowedBefore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.bookingAllowedBefore = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v("\n                                        min\n                                    ")])])])])]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.saveSettings
    }
  }, [_c('i', {
    staticClass: "checkmark icon"
  }), _vm._v(" Save settings")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89e7950a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Settings.vue
// module id = 745
// module chunks = 1